var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "setor" },
    [
      _c("h3", { staticClass: "titulo" }, [_vm._v(_vm._s(_vm.titulo))]),
      _c(
        "el-row",
        { staticClass: "pesquisa", attrs: { gutter: 12 } },
        [
          _c("el-col", { attrs: { lg: 8, md: 9, sm: 24 } }, [
            _c("p", { staticClass: "label" }, [_vm._v("Selecionar período:")]),
            _c(
              "form",
              [
                _c(
                  "el-date-picker",
                  _vm._b(
                    {
                      staticClass: "full-width input",
                      attrs: {
                        type: "daterange",
                        "unlink-panels": "unlink-panels",
                        placeholder: "Selecione",
                        "range-separator": "a",
                        format: "dd/MM/yyyy",
                        "start-placeholder": "Data inicial",
                        "end-placeholder": "Data final",
                        name: "prazo",
                        "picker-options": _vm.options,
                        clearable: false
                      },
                      model: {
                        value: _vm.filtro.dateRange,
                        callback: function($$v) {
                          _vm.$set(_vm.filtro, "dateRange", $$v)
                        },
                        expression: "filtro.dateRange"
                      }
                    },
                    "el-date-picker",
                    _vm.$attrs,
                    false
                  )
                )
              ],
              1
            )
          ])
        ],
        1
      ),
      _c("el-row", [
        _c(
          "div",
          { staticClass: "button-pesquisar" },
          [
            _c(
              "el-button",
              {
                staticClass: "margin-button",
                attrs: { type: "text" },
                on: { click: _vm.limparPesquisa }
              },
              [_vm._v(" Limpar filtro")]
            ),
            _c(
              "el-button",
              {
                staticClass: "margin-button",
                attrs: { type: "primary" },
                on: { click: _vm.pesquisar }
              },
              [
                _c("i", { staticClass: "icon fa fa-search" }),
                _vm._v(" Pesquisar")
              ]
            )
          ],
          1
        )
      ]),
      _c("el-row", { staticClass: "margin", attrs: { gutter: 10 } }, [
        _vm.hasDados
          ? _c(
              "div",
              [
                _c(
                  "el-col",
                  { staticClass: "width-100", attrs: { sm: 24 } },
                  [
                    _c(
                      "el-card",
                      { staticClass: "box-card", attrs: { shadow: "hover" } },
                      [
                        _vm._t("header", [
                          _c("h3", [_vm._v("Produtividade dos setores")])
                        ]),
                        _c(
                          "div",
                          [
                            _c("grafico-processo-por-setor", {
                              attrs: {
                                dadosLabels:
                                  _vm.produtividade.produtividadeSetores,
                                filtro: _vm.filtro
                              },
                              on: {
                                produtividadePorSetor: _vm.produtividadePorSetor
                              }
                            })
                          ],
                          1
                        )
                      ],
                      2
                    )
                  ],
                  1
                )
              ],
              1
            )
          : _c("div", { staticClass: "flex" }, [
              _c("div", { staticClass: "border-top-bottom" }, [
                _c("span", { staticClass: "cinza" }, [
                  _vm._v("Não existem resultados para serem exibidos.")
                ])
              ])
            ])
      ]),
      _c(
        "div",
        { staticClass: "margin" },
        [
          _c(
            "el-button",
            {
              staticClass: "btn",
              attrs: { type: "default" },
              on: {
                click: function($event) {
                  return _vm.voltar()
                }
              }
            },
            [_c("i", { staticClass: "fa fa-chevron-left" }), _vm._v("  Voltar")]
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-175dc21c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-175dc21c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/screens/produtividade/rr/Home.vue
// module id = null
// module chunks = 